module.exports = __webpack_public_path__ + "fonts/dosis-v8-latin_latin-ext-700.ttf";